import React, { useState, useRef, useEffect } from "react";
import "./HomeMainFeed.scss";

const HomeMainFeed = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const popupRef = useRef(null);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
    document.body.style.overflow = !isPopupOpen ? "hidden" : "auto"; // Prevent scrolling when popup is open
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      togglePopup();
    }
  };

  const handleEscapeKey = (event) => {
    if (event.key === "Escape") {
      togglePopup();
    }
  };

  useEffect(() => {
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscapeKey);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  });

  return (
    <div className="homeMainFeedContainer">
      <div className="componentHeader">
        <div className="post-container">
          <img src="/user.svg" alt="" />
          <div onClick={togglePopup} className="post-box">
            <span>Start a post, trying with AI </span>
          </div>
        </div>
        <div className="post-icons-container">
          <div className="post-icons">
            <img src="/image-icon.png" alt="" />
            Media
          </div>
          <div className="post-icons">
            <img src="/calendar.svg" alt="" />
            Event
          </div>
          <div className="post-icons">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
              />
            </svg>
            Write Article
          </div>
        </div>
      </div>

      {/* Post container (popup) */}
      {isPopupOpen && (
        <div className="post-popup">
          <div className="post-subcontainer" ref={popupRef}>
            <div className="popup-cancel-header">
              <div className="post-profile">
                <img src="/user.svg" alt="" />
                <span>
                  <h1>David Maduabuchi</h1>
                  <p>Post to Anyone</p>
                </span>
                <img src="/down-icon.svg" alt="" className="popup-down-icon" />
              </div>
              <img
                src="/cancel.svg"
                alt=""
                className="popup-cancel-icon"
                onClick={togglePopup}
              />
            </div>
            <textarea
              value={inputValue}
              onChange={handleChange}
              placeholder="What do you want to talk about?"
              type="text"
            >
              What do you want to say?  
            </textarea>
            <hr />
            <button
              disabled={!inputValue}
              className={!inputValue ? "disabled-button" : "button"}
            >
              Post
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeMainFeed;
